var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalMoreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 7.33594C17.9889 7.33594 19.332 5.99279 19.332 4.33594C19.332 2.67908 17.9889 1.33594 16.332 1.33594C14.6752 1.33594 13.332 2.67908 13.332 4.33594C13.332 5.99279 14.6752 7.33594 16.332 7.33594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 18.7891C17.9889 18.7891 19.332 17.4459 19.332 15.7891C19.332 14.1322 17.9889 12.7891 16.332 12.7891C14.6752 12.7891 13.332 14.1322 13.332 15.7891C13.332 17.4459 14.6752 18.7891 16.332 18.7891Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 30.2441C17.9889 30.2441 19.332 28.901 19.332 27.2441C19.332 25.5873 17.9889 24.2441 16.332 24.2441C14.6752 24.2441 13.332 25.5873 13.332 27.2441C13.332 28.901 14.6752 30.2441 16.332 30.2441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalMoreWhite);
export default __webpack_public_path__ + "static/media/VerticalMoreWhite.4917484357008ddb748428ff3b82c00e.svg";
export { ForwardRef as ReactComponent };